module.exports = __webpack_public_path__ + "static/img/cup.db6186e6.png";